// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__ivhlT","heading":"styles_heading__2fULL","image":"styles_image__dcShq","subhead":"styles_subhead__G1Qkn","reflow":"styles_reflow__SlukC"};